import KeenSlider, { KeenSliderInstance } from "keen-slider";
import { whenDomReady } from "@allwyn/utils/document-ready";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import { onViewportEnter } from "@sazka/utils/viewport-enter";

function initRecommendedCarousel(section: HTMLElement) {
    const sliderEl = section.querySelector<HTMLElement>("[data-js-carousel]");
    const arrowLeft = section.querySelector<HTMLButtonElement>("[data-js-carousel-prev]");
    const arrowRight = section.querySelector<HTMLButtonElement>("[data-js-carousel-next]");

    if (!sliderEl) {
        return;
    }

    function updateArrows(slider: KeenSliderInstance) {
        const { abs, maxIdx } = slider.track.details;

        if (arrowLeft) {
            arrowLeft.disabled = abs === 0;
        }
        if (arrowRight) {
            arrowRight.disabled = abs === maxIdx;
        }
    }

    function onCreated(slider: KeenSliderInstance) {
        slider.container.classList.add("loaded");
        updateArrows(slider);
    }

    const slider = new KeenSlider(sliderEl, {
        slides: {
            perView: 1,
            spacing: 12,
        },
        breakpoints: {
            [`(min-width: ${ResponsiveUtils.breakpoints.xs2}px)`]: {
                slides: { perView: 2, spacing: 12 },
            },
            [`(min-width: ${ResponsiveUtils.breakpoints.sm2}px)`]: {
                slides: { perView: 3, spacing: 16 },
            },
            [`(min-width: ${ResponsiveUtils.breakpoints.lg}px)`]: {
                slides: { perView: 4, spacing: 16 },
            },
        },
        created: onCreated,
        slideChanged: updateArrows,
        updated: updateArrows,
    });

    arrowLeft?.addEventListener("click", () => slider.prev());
    arrowRight?.addEventListener("click", () => slider.next());
}

await whenDomReady();

const sections = document.querySelectorAll<HTMLElement>(".hsr-blog-article__recommended");
sections.forEach((section) => {
    onViewportEnter(section, 0.2).then(() => {
        initRecommendedCarousel(section);
    });
});
